/* eslint-disable no-console */
import { addToEpiCart } from './utils/cart-utils';
import { gaAddToCart } from './utils/ga-ecommerce-utils';

export default class EasyShadeAddToCart {
  constructor() {
    this.getModelAndHousingCodesUrl = window.getModelAndHousingCodesUrl;
    this.itemPrefix = window.itemPrefix;
    this.addToCartBtn = document.querySelector('.add-to-cart-btn');
    this.qtyIpts = document.querySelectorAll('.line-item-quantity');
    this.orderItems = [];
    this.orderFormattedAsLineItems = [];
    this.modelHousingCodes = [];
    this.addToCartRedirectUrl = window.addToCartRedirectUrl;
    this.addToOrderLine = window.addToCartRedirectUrl;
    this.addToCartErrorMessage = window.addToCartErrorMessage;
    this.init();
  }

  getGetModelAndHousingCodeData() {
    return new Promise((resolve, reject) => {
      fetch(this.getModelAndHousingCodesUrl, {
        method: 'GET',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
      })
        .then((response) => {
          if (response.ok) {
            response.json().then(resolve);
          } else {
            response.json().then(reject);
          }
        })
        .catch(console.error);
    });
  }

  addToCart() {
    // console.log(this.orderItems);
    if (this.orderItems.length === 0) {
      this.addToCartBtn.classList.remove('updating');
      this.addToCartBtn.removeAttribute('disabled');
      window.location = this.addToCartRedirectUrl;
      return;
    }
    addToEpiCart(this.orderItems[0])
      .then(() => {
        gaAddToCart(this.orderItems[0], 'EasyShades')
          .then(() => {
            // Remove item added from array
            this.orderItems.shift();
            // Rerun addToCart until empty
            this.addToCart();
          })
          .catch((error) => {
            this.displayAddToCartError(error);
          });
      })
      .catch((error) => {
        this.displayAddToCartError(error);
      });
  }

  getModelCodeForOrder(model, housingColor) {
    const code = this.modelHousingCodes.find(c => c.Name === `${model}${housingColor}`);
    if (code) {
      return code.Id;
    }
    return '';
  }

  getLineItemOrderCode(lineItem) {
    const sizeVal = lineItem.querySelector('.line-item-size').value;
    const modelVal = lineItem.querySelector('.line-item-model').value;
    const shadeColorVal = lineItem.querySelector('.line-item-shade-color').value;
    const housingColorVal = lineItem.querySelector('.line-item-housing-color').value;
    const modelHousingCode = this.getModelCodeForOrder(modelVal, housingColorVal);
    const leftMotorMount = (modelVal === '2') ? 'L' : '';
    if (modelHousingCode === '') {
      return '';
    }
    return `${this.itemPrefix}${modelHousingCode}${shadeColorVal}${sizeVal}${leftMotorMount}`;
  }

  displayAddToCartError(error) {
    const { alert } = window;
    console.log(error);
    alert(this.addToCartErrorMessage);
    this.addToCartBtn.classList.remove('updating');
    this.addToCartBtn.removeAttribute('disabled');
  }

  createOrderQueue() {
    // Wipe any items from previous order queue
    this.orderItems = [];
    this.orderFormattedAsLineItems = [];
    // Loop through line items w/ a quantity specified
    [].map.call(this.qtyIpts, (ipt) => {
      if (ipt.value !== '' && ipt.value !== '0') {
        const ct = parseInt(ipt.value, 10);
        const lineItem = ipt.closest('tr');
        const lineItemCode = this.getLineItemOrderCode(lineItem);
        // Add to cart/order queue
        for (let i = 0; i < ct; i++) { /* eslint-disable-line no-plusplus */
          this.orderItems.push(lineItemCode);
        }
        // Add object to this.orderFormattedAsLineItems
        this.orderFormattedAsLineItems.push({
          itemNumber: lineItemCode,
          quantity: ct,
        });
      }
    });
  }

  init() {
    const that = this;
    // Get model codes needed to create item number on order
    this.getGetModelAndHousingCodeData()
      .then((data) => {
        this.modelHousingCodes = data;
      });

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', () => {
        this.addToCartBtn.classList.add('updating');
        this.addToCartBtn.setAttribute('disabled', 'disabled');
        that.createOrderQueue();
        // If queue is empty, throw alert
        if (this.orderItems.length === 0) {
          this.addToCartBtn.classList.remove('updating');
          this.addToCartBtn.removeAttribute('disabled');
          const { alert, noItemsSelectedErrorMessage } = window;
          alert(noItemsSelectedErrorMessage);
          return;
        }
        // Add to order lines before adding to EPi cart
        fetch('AddToCart', {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            lineItems: this.orderFormattedAsLineItems,
          }),
        })
          .then(that.addToCart())
          .catch((error) => {
            this.displayAddToCartError(error);
          });
      });
    }
  }
}
window.EasyShadeAddToCart = EasyShadeAddToCart;
/* eslint-enable no-console */
